import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { CurrentLanguage } from '../common-services/current-language.service';
import { SecureStorage } from '../common-services/SecureStorage.service';
import { EncryptionService } from './encryption.service';
import { FileUploadModel } from './../business-entities/document-model';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  cultureCode: string;
  timeZone: string;
  callHistoryId: string = "";
  isloggingIn: boolean = false;
  isloggedout: boolean = false;

  constructor(
    private readonly encryptionService: EncryptionService,
    private readonly http: HttpClient,
    private readonly currentLanguage: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
  ) {
    this.getCultureCode();
    this.getTimeZoneInfo();
    this.getcallHistoryId();
  }
  getCultureCode = (): void => {
    this.currentLanguage.cultureCodeSubject.subscribe(x => {
      if (x === null || x === '') {
        this.cultureCode = this.secureStorage.getKeyData('CultureCode')
      }
      else {
        this.cultureCode = x;
      }
    });
  }

  getTimeZoneInfo = (): void => {
    this.currentLanguage.timeZoneStandradName.subscribe(x => {
      if (x === null || x === '') {
        this.timeZone = this.secureStorage.getKeyData('TimeZoneStandradName')
      }
      else {
        this.timeZone = x;
      }
    });
  }

  getcallHistoryId = (): void => {
    this.currentLanguage.callHistoryId.subscribe(x => {
      if (+x > 0) {
        this.callHistoryId = x
      }
      else {
        this.callHistoryId = "";
      }
    });
  }

  private prepareOptions(
    isContentTypeEnabled: boolean = true,
    params: any = null): any {
    this.getCultureCode();
    this.getcallHistoryId();
    let headers = new HttpHeaders();
    this.cultureCode = this.cultureCode === undefined ? '' : this.cultureCode
    this.timeZone = this.timeZone === undefined ? '' : this.timeZone
    headers = headers
      // Authorization header will be automatically added with token with msal browser interceptors
      .set('Accept', 'application/json')
      .set('CultureCode', this.cultureCode)
      .set('TimeZone', this.timeZone)
      .set('cxhd', this.callHistoryId);
    if (isContentTypeEnabled) {
      headers = headers.set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');
    }
    if (params != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(params))
      );
    }

    return { headers };
  }
  private preparePdfOptions(params: any = null): any {
    this.getCultureCode();
    this.getcallHistoryId();
    let headers = new HttpHeaders();
    this.cultureCode = this.cultureCode === undefined ? '' : this.cultureCode
    this.timeZone = this.timeZone === undefined ? '' : this.timeZone
    headers = headers
      .set('Accept', 'application/json')
      .set('CultureCode', this.cultureCode)
      .set('TimeZone', this.timeZone)
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('cxhd', this.callHistoryId);
    if (params != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(params))
      );
    }

    return { headers: headers, responseType: 'blob' as 'blob' };
  }
  private prepareFileUploadOptions(payload: any = null): any {
    this.getCultureCode();
    let headers = new HttpHeaders();
    this.cultureCode = this.cultureCode === undefined ? '' : this.cultureCode
    this.timeZone = this.timeZone === undefined ? '' : this.timeZone
    headers = headers
      .set('Accept', 'application/json')
      .set('CultureCode', this.cultureCode)
      .set('TimeZone', this.timeZone)
      .set('Access-Control-Allow-Origin', '*');
    if (payload != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(payload))
      );
    }
    return { headers: headers };
  }

  private prepareOptionsForLocalizationService(
    isContentTypeEnabled: boolean = true,
    params: any = null): any {
    let headers = new HttpHeaders();

    headers = headers
      .set('Accept', 'application/json')
    if (isContentTypeEnabled) {
      headers = headers.set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');
    }
    if (params != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(params))
      );
    }

    return { headers };
  }

  private prepareOptionsForSmsService(
    isContentTypeEnabled: boolean = true,
    params: any = null): any {
    let headers = new HttpHeaders();

    headers = headers
      .set('Accept', 'application/json')
    if (isContentTypeEnabled) {
      headers = headers.set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');
    }
    if (params != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(params))
      );
    }

    return { headers };
  }

  private prepareOptionsForCampaignService(
    isContentTypeEnabled: boolean = true,
    params: any = null): any {
    let headers = new HttpHeaders();

    headers = headers
      .set('Accept', 'application/json')
    if (isContentTypeEnabled) {
      headers = headers.set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');
    }
    if (params != null) {
      headers = headers.set(
        'Payload',
        this.encryptionService.encryptText(JSON.stringify(params))
      );
    }

    return { headers };
  }

  private prepareoptionsForCheckInValidate(
    isContentTypeEnabled: boolean = true,
    params: any = null): any {
    let headers = new HttpHeaders();

    headers = headers
      .set('Accept', 'application/json')
    if (isContentTypeEnabled) {
      headers = headers.set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*');
    }
    if (params != null) {
      headers = headers.set(
        'Payload',
        params
      );
    }

    return { headers };
  }

  GetAll<T>(uri: string) {
    const options = this.prepareOptions();
    return this.http.get(`${uri}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }


  GetAllwithHeaders<T>(uri: string, params: any) {
    const options = this.prepareOptions(true, params);
    return this.http.get(`${uri}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }
  GetFileWithHeader(uri: string, params: any) {
    const options = this.preparePdfOptions(params);
    return this.http.get(`${uri}`, options);
  }

  Get<T>(uri: string, ...params: any[]) {
    const options = this.prepareOptions();
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    return this.http.get(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }
  GetNonEnc<T>(uri: string, ...params: any[]) {
    const options = this.prepareOptions();
    const paramsString: string = params
      .map(param => encodeURIComponent(param.toString()))
      .join('/').replace(/[%]/g, '!');
    return this.http.get(`${uri}/${paramsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  GetFile<T>(uri: string) {
    const options = this.prepareFileOptions();
    return this.http.get(`${uri}`, options);
  }

  prepareFileOptions() {
    this.getcallHistoryId();
    let headers = new HttpHeaders();
    headers = headers
      .set('Accept', 'application/json')
      .set('CultureCode', this.cultureCode)
      .set('TimeZone', this.timeZone)
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('cxhd', this.callHistoryId);
    return { headers: headers, responseType: 'blob' as 'json' };
  }

  GetForLocalization<T>(uri: string, ...params: any[]) {
    const options = this.prepareOptionsForLocalizationService();
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    return this.http.get(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }
  PostWithHeaders<T>(uri: string, params: any, httpOptions?: any) {
    const options = this.prepareOptions();
    if (httpOptions && httpOptions.responseType) {
      options.responseType = httpOptions.responseType;
    }
    return this.http
      .post(
        uri,
        this.encryptionService.encryptText(JSON.stringify(params)),
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }
  PostFiles<T>(uri: string, payload: any, files: FileUploadModel[]) {
    const options = this.prepareFileUploadOptions(payload);
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files[i].uniqueId, files[i].file, files[i].file.name);
    }
    return this.http.post(uri, formData, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }
  Post<T>(uri: string, params: any) {
    const options = this.prepareOptions();
    return this.http
      .post(
        uri,
        this.encryptionService.encryptText(JSON.stringify(params)),
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }

  PostWithOutToken<T>(uri: string, params: any) {
    const options = this.prepareOptionsForSmsService();
    return this.http
      .post(
        uri,
        this.encryptionService.encryptText(JSON.stringify(params)),
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }

  GetWithoutToken<T>(uri: string, ...params: any[]) {
    const options = this.prepareOptionsForSmsService();
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    return this.http.get(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  PostForm<T>(uri: string, params: any) {
    const options = this.prepareOptions(false);
    return this.http.post(uri, params, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  Put<T>(uri: string, params: any) {
    const options = this.prepareOptions();
    return this.http
      .put(
        uri,
        this.encryptionService.encryptText(JSON.stringify(params)),
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }

  PutForm<T>(uri: string, params: any) {
    const options = this.prepareOptions(false);
    return this.http
      .put(
        uri,
        params,
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }

  Patch<T>(uri: string, params: any) {
    const options = this.prepareOptions();
    return this.http
      .patch(
        uri,
        this.encryptionService.encryptText(JSON.stringify(params)),
        options
      )
      .pipe(
        catchError(err => {
          return err;
        }),
        map((response: T) => {
          return response;
        })
      );
  }

  Delete<T>(uri: string, params: any) {
    const options = this.prepareOptions();
    const encryptedUrl = encodeURIComponent(
      this.encryptionService.encryptText(params.toString())
    ).replace(/[%]/g, '!');
    return this.http.delete(`${uri}/${encryptedUrl}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  DeleteWithParams<T>(uri: string, ...params: any[]) {
    const options = this.prepareOptions();
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    return this.http.delete(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  GetForCampaignService<T>(uri: string) {
    const options = this.prepareOptionsForCampaignService();
    return this.http.get(`${uri}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  GetForCampaignServicePayload<T>(uri: string, params: any) {
    const options = this.prepareOptionsForCampaignService(true, params);
    return this.http.get(`${uri}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  GetForCampaignServiceWithParam<T>(uri: string, ...params: any[]) {
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    const options = this.prepareOptionsForCampaignService();
    return this.http.get(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  PostForCampaignService<T>(uri: string, params: any) {
    const options = this.prepareOptionsForCampaignService();
    return this.http.post(`${uri}`, this.encryptionService.encryptText(JSON.stringify(params)), options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  CheckInValidate<T>(uri: string, params: any){
    const options = this.prepareoptionsForCheckInValidate();
    return this.http.post(`${uri}`,  JSON.stringify(params), options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }

  DeleteForCampaignService<T>(uri: string, ...params: any[]) {
    const encryptedParamsString: string = params
      .map(param =>
        encodeURIComponent(this.encryptionService.encryptText(param.toString()))
      )
      .join('/')
      .replace(/[%]/g, '!');
    const options = this.prepareOptionsForCampaignService();
    return this.http.delete(`${uri}/${encryptedParamsString}`, options).pipe(
      catchError(err => {
        return err;
      }),
      map((response: T) => {
        return response;
      })
    );
  }
}
